const OWASP = {
    REQUIRED: "Campo Obligatorio",
    LENGTH_11: 11,
    VALIDATIONS: {
        GENERAL: /^(?!.*\b(?:DECLARE|DROP|EXEC|USE|LOCK|GRANT|REVOKE|REPLICATE|SYNCHRONIZE|ALTER|SCRIPT|TRUNCATE|TABLE|SELECT|INSERT|UPDATE|DELETE|CREATE|DATABASE|FROM|ORDER|WHERE|INTO|CONCAT|LIKE|AND|UNION|SET)\b)[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ@.\s#_(),\/-]{1,255}$/i,
        ONLY_LETTERS: /^(?!.*\b(?:DECLARE|DROP|EXEC|USE|LOCK|GRANT|REVOKE|REPLICATE|SYNCHRONIZE|ALTER|SCRIPT|TRUNCATE|TABLE|SELECT|INSERT|UPDATE|DELETE|CREATE|DATABASE|FROM|ORDER|WHERE|INTO|CONCAT|LIKE|AND|UNION|SET)\b)[a-zA-ZáéíóúüÁÉÍÓÚÜñÑ\s]{1,255}$/i,
        ONLY_NUMBER_LETTERS: /^(?!.*\b(?:DECLARE|DROP|EXEC|USE|LOCK|GRANT|REVOKE|REPLICATE|SYNCHRONIZE|ALTER|SCRIPT|TRUNCATE|TABLE|SELECT|INSERT|UPDATE|DELETE|CREATE|DATABASE|FROM|ORDER|WHERE|INTO|CONCAT|LIKE|AND|UNION|SET)\b)[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s]{1,255}$/i,
        ONLY_NUMBERS_INTEGER: /^[0-9]+$/,
        ONLY_NUMBERS_INTEGER_DAYS: /^[1-7]+$/,
        ONLY_NUMBER_DAYS_GRACIA: /^[0-7]$/,
        ONLY_NUMBERS_INTEGER_TINYINT: /^(100|[1-9][0-9]?)$/,
        ONLY_NUMBERS_INCLUDE_NEGATIVES: /^-?\d+(\.\d+)?$/,
        ONLY_NUMBERS_DECIMAL: /^\d{1,3}$/,
        ONLY_NUMBERS_DECIMAL_INCLUDE_ZERO: /^\d+(\.\d{1,2})?$/,
        ONLY_PERCENTAGES: /^(100(\.0{1,2})?|(\d{1,2}|\d{1,2}\.\d{1,2}))$/,
        ONLY_MONEY: /^\d{1,10}(\.\d{2})?$/,
        ONLY_DECIMALS_NOT_ZERO_NEGATIVE: /^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:0?[1-9]|[1-9]\d?))$/,
        ID_INTERNO: /^[A-Z_]{1,10}$/,
        ID_INTERNO_50: /^[A-Z_]{1,50}$/,
        EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        DATE: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
        USER: /^[A-Za-z0-9_]{4,10}$/
    },
    MESSAGES: {
        DEFAULT: "Entrada no válida",
        INVALID: ""
    }
};

export default OWASP;